module.exports = __webpack_public_path__ + "img/pp9.bd1b53aa.png";